import { render, staticRenderFns } from "./TemplateEventsSummary.vue?vue&type=template&id=526a6d9a&scoped=true&"
import script from "./TemplateEventsSummary.vue?vue&type=script&lang=js&"
export * from "./TemplateEventsSummary.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEventsSummary.vue?vue&type=style&index=0&id=526a6d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a6d9a",
  null
  
)

export default component.exports